
  import createMeisterIcons from '../src/createMeisterIcons';

  const SquareB = createMeisterIcons("square-b", [["path",{"fill":"currentColor","d":"M21 3H3v18h18z","key":"e3250235d39b6f611c538f9ee891a5fdd2b9532f","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"M2.25 2.25h19.5v19.5H2.25zm1.5 1.5v16.5h16.5V3.75z","key":"88546a91b71e7654da11902d752ad34df8addfff","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default SquareB
  